import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { makeStyles } from "@material-ui/core/styles";
import { debounce } from "lodash";
import ReactDOM from "react-dom";

const ShinyDashboard = (props) => {
    const useStyles = makeStyles((theme) => ({
        editor: {
            height: "100px",
        },
        dashBoardLink: {
            margin: "10px",
        },
        linkWarning: {
            margin: "10px",
            backgroundColor: "yellow",
        },
    }));
    const classes = useStyles();
    const handleClick = () => {
        window.open(
            "https://anacap.anacapgs.com:8443/app/voyager",
            "Windows",
            "toolbar=no,status=no,location=no,width=999,height=666,"
        );
    };
    const handleClick2 = () => {
        window.open(
            "https://anacap.anacapgs.com:8443/app/casino",
            "Windows",
            "toolbar=no,status=no,location=no,width=999,height=666,"
        );
    };
    const handleClick3 = () => {
        window.open(
            "https://anacap.anacapgs.com:8443/app/anfora",
            "Windows",
            "toolbar=no,status=no,location=no,width=999,height=666,"
        );
    };
    const handleClick4 = () => {
        window.open(
            "https://anacap.anacapgs.com:8443/app/berrylium",
            "Windows",
            "toolbar=no,status=no,location=no,width=999,height=666,"
        );
    };
    return (
        <div>
            <div>
                <span className={classes.dashBoardLink}>
                    <a
                        id="btnFrame"
                        height="20px"
                        width="50px"
                        href="https://anacap.anacapgs.com:8443/app/anfora"
                        target="myFrame"
                    >
                        Anfora
                    </a>
                </span>
                <span className={classes.dashBoardLink}>
                    <button onClick={handleClick3}>Anfora</button>
                </span>
                <span className={classes.dashBoardLink}>
                    <a
                        id="btnFrame2"
                        height="20px"
                        width="50px"
                        href="https://anacap.anacapgs.com:8443/app/berrylium"
                        target="myFrame"
                    >
                        Berrylium
                    </a>
                </span>
                <span className={classes.dashBoardLink}>
                    <button onClick={handleClick4}>Berrylium</button>
                </span>
                <span className={classes.dashBoardLink}>
                    <a
                        id="btnFrame3"
                        height="20px"
                        width="50px"
                        href="https://anacap.anacapgs.com:8443/app/voyager"
                        target="myFrame"
                    >
                        Voyager
                    </a>
                </span>
                <span className={classes.dashBoardLink}>
                    <button onClick={handleClick}>Voyager</button>
                </span>
                <span className={classes.dashBoardLink}>
                    <a
                        id="btnFrame4"
                        height="20px"
                        width="50px"
                        href="https://anacap.anacapgs.com:8443/app/casino"
                        target="myFrame"
                    >
                        Casino
                    </a>
                </span>
                <span className={classes.dashBoardLink}>
                    <button onClick={handleClick2}>Casino</button>
                </span>

                <span className={classes.linkWarning}>
                    Shiny dashboard demostration using -
                    <b>https://anacap.anacapgs.com:8443/</b>
                </span>
            </div>

            <div>
                <iframe
                    height="800px"
                    width="1480px"
                    // src="https://ana457:8443/"
                    src="https://anacap.anacapgs.com:8443/"
                    target="_parent"
                    id="fr"
                    name="myFrame"
                />
            </div>
        </div>
    );
};
export default ShinyDashboard;
